import type { Command, CommandContext, CommandResult, EditorSelectionState } from "./Command";

export class UpdateSelectionCommand implements Command {
  readonly id = "editor.selection.update";
  readonly label = "Update Selection";
  readonly affectsDocument = false;

  constructor(private readonly nextSelection: EditorSelectionState) {}

  execute(context: CommandContext): CommandResult {
    context.selection = structuredClone(this.nextSelection);
    return emptyResult();
  }

  undo(_context: CommandContext): CommandResult {
    return emptyResult();
  }

  redo(context: CommandContext): CommandResult {
    return this.execute(context);
  }
}

function emptyResult(): CommandResult {
  return {
    changedNodeIds: [],
    affectedBounds: [],
  };
}
